import React from 'react';

interface IDocProps {
  guide: string;
  useCase: string;
  assessment: string;
}

const DocsTab: React.FC<IDocProps> = (props: IDocProps) => {
  const { guide, useCase, assessment } = props;

  return (
    <div className='bite-u-tab-cont'>
      <h1>Course Materials</h1>
      <a href={guide} target='_blank' rel='noopener noreferrer' style={{ color: '#4895EF', fontWeight: 600, fontFamily: 'Inter', fontStyle: 'normal' }}>Training Guide</a>
      <a href={useCase} target='_blank' rel='noopener noreferrer' style={{ color: '#4895EF', fontWeight: 600, fontFamily: 'Inter', fontStyle: 'normal' }}>Additional Use Case</a>
      <a href={assessment} target='_blank' rel='noopener noreferrer' style={{ color: '#4895EF', fontWeight: 600, fontFamily: 'Inter', fontStyle: 'normal' }}>Final Learning Assessment</a>
    </div>
  );
};

export default DocsTab;
